"use client";

import React from "react";
import { createIcon } from "@chakra-ui/react";

const FacebookIcon = createIcon({
  displayName: "FacebookIcon",
  viewBox: "0 0 23.37 45",
  path: (
    <>
      <path
        d="M15.17,45v-20.53h6.89l1.03-8h-7.92v-5.11c0-2.32.64-3.89,3.97-3.89h4.23V.31c-.73-.1-3.25-.31-6.17-.31C11.09,0,6.91,3.73,6.91,10.57v5.9H0v8h6.91v20.53h8.26Z"
        fill="currentColor"
      />
    </>
  ),
  defaultProps: {
    boxSize: "1em",
  },
});

export default FacebookIcon;
